import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { useMemo } from 'react';
import { SuspenseBoundary } from '../../../shared/SuspenseBoundary';
import { useAppPermissionTranslations } from '../translation';
import { useIsUngatedForBETranslations } from '../translation/internal/ungated-for-be-translations';
import ScopesAuthorization from './ScopesAuthorization';
import { jsx as _jsx } from "react/jsx-runtime";
export const useTranslateScopeGroups = (scopeGroups, ungatedForBETranslation) => {
  // since scopeGroups are synced with app permissions, we can converge on the app permission names
  const appPermissionNames = useMemo(() => {
    return new Set(scopeGroups.map(scopeGroup => scopeGroup.name));
  }, [scopeGroups]);
  const translations = useAppPermissionTranslations(appPermissionNames, ungatedForBETranslation);
  return useMemo(() => {
    return scopeGroups.map(scopeGroup => {
      var _translations$get;
      return Object.assign({}, scopeGroup, {
        translations: (_translations$get = translations.get(scopeGroup.name)) !== null && _translations$get !== void 0 ? _translations$get : {
          name: scopeGroup.name,
          ungatedForBETranslation,
          shortDescription: undefined,
          longDescription: undefined
        }
      });
    });
  }, [scopeGroups, translations, ungatedForBETranslation]);
};
const ScopesAuthorizationContent = ({
  scopes,
  ungatedForBETranslation
}) => {
  const translatedScopes = useTranslateScopeGroups(scopes, ungatedForBETranslation);
  return /*#__PURE__*/_jsx(ScopesAuthorization, {
    scopes: translatedScopes
  });
};
const Loading = () => /*#__PURE__*/_jsx(LoadingSpinner, {
  grow: true,
  minHeight: 200
});
const ScopesAuthorizationContainer = props => {
  const [isLoading, ungatedForBETranslation] = useIsUngatedForBETranslations();
  if (isLoading) {
    return /*#__PURE__*/_jsx(Loading, {});
  }
  return /*#__PURE__*/_jsx(SuspenseBoundary, {
    fallback: /*#__PURE__*/_jsx(Loading, {}),
    children: /*#__PURE__*/_jsx(ScopesAuthorizationContent, {
      scopes: props.scopes,
      ungatedForBETranslation: ungatedForBETranslation
    })
  });
};
export default ScopesAuthorizationContainer;